function LayersThreeIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.12"
        d="M16.4771 2.90543C16.3022 2.81798 16.2147 2.77425 16.123 2.75704C16.0418 2.74179 15.9584 2.74179 15.8771 2.75704C15.7854 2.77425 15.698 2.81798 15.5231 2.90543L2.66675 9.33358L15.5231 15.7617C15.698 15.8492 15.7854 15.8929 15.8771 15.9101C15.9584 15.9254 16.0418 15.9254 16.123 15.9101C16.2147 15.8929 16.3022 15.8492 16.4771 15.7617L29.3334 9.33358L16.4771 2.90543Z"
        fill="currentColor"
      />
      <path
        d="M2.66675 15.9998L15.5231 22.4279C15.698 22.5154 15.7854 22.5591 15.8771 22.5763C15.9584 22.5916 16.0418 22.5916 16.123 22.5763C16.2147 22.5591 16.3022 22.5154 16.4771 22.4279L29.3334 15.9998M2.66675 22.6664L15.5231 29.0946C15.698 29.182 15.7854 29.2258 15.8771 29.243C15.9584 29.2582 16.0418 29.2582 16.123 29.243C16.2147 29.2258 16.3022 29.182 16.4771 29.0946L29.3334 22.6664M2.66675 9.33309L15.5231 2.90494C15.698 2.81749 15.7854 2.77376 15.8771 2.75655C15.9584 2.74131 16.0418 2.74131 16.123 2.75655C16.2147 2.77376 16.3022 2.81749 16.4771 2.90494L29.3334 9.33309L16.4771 15.7612C16.3022 15.8487 16.2147 15.8924 16.123 15.9096C16.0418 15.9249 15.9584 15.9249 15.8771 15.9096C15.7854 15.8924 15.698 15.8487 15.5231 15.7612L2.66675 9.33309Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LayersThreeIcon;
